<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.arsAffiliates')"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3">
      <v-row class="py-lg-16 justify-sm-center">
        <v-col
          cols="12"
          lg="3"
          sm="5"
          v-for="(medicalInsurance, index) in medicalInsurance"
          :key="index"
        >
          <v-card
            class="mx-auto shadow-1 mb-lg-5 rounded-xl justify-center d-flex"
            max-width="270"
            height="168px"
          >
            <v-img :src="medicalInsurance.upload.path" max-width="130" contain>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import MedicalInsuranceService from "@/services/medicalInsurance";
export default {
  name: "MedicalInsurance",
  data() {
    return {
      medicalInsurance: [],
    }
  },
  async created() {
      this.medicalInsurance = await MedicalInsuranceService.getMedicalInsurance();
  },
};
</script>
